//https://www.hendrikjansen.nl/henk/streaming.html
export default [
    {
        id: 0,
        post_title: 'Show',
        fields: {
            broadcast_image: {
                sizes: {
                    thumbnail: ''
                }
            }
        },
        programs: [
            {
                name: 'Name'
            }
        ],
        speakers: [
            {
                name: 'Speaker'
            }
        ],
        img: '',
        url: 'https://playerservices.streamtheworld.com/api/livestream-redirect/CLASSICFM.mp3'
    },
    {
        id: 1,
        post_title: 'Show',
        fields: {
            broadcast_image: {
                sizes: {
                    thumbnail: ''
                }
            }
        },
        programs: [
            {
                name: 'Name'
            }
        ],
        speakers: [
            {
                name: 'Speaker'
            }
        ],
        img: '',
        url: 'https://trans-world-radio.ams3.digitaloceanspaces.com/Titus-3-vers-1-en-2.mp3'
    },
]